import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { tv } from './tv'
// import {getUser} from '@/api'
import customization from './customization'

Vue.use(VueRouter)
const login = [
  {
    path: '/login',
    title: '登录',
    meta: { requireAuth: false },
    component: () => import('@/views/login')
  },
  {
    path: '/loginSelectOrg',
    title: '选择机构',
    meta: { requireAuth: false },
    component: () => import('@/views/login/loginSelectOrg.vue')
  },
  {
    path: '/regist',
    title: '注册',
    meta: { requireAuth: false },
    component: () => import('@/views/login/regist.vue')
  },
  {
    path: '/registChooseOrg',
    title: '注册',
    meta: { requireAuth: false },
    component: () => import('@/views/login/registChooseOrg.vue')
  },
  {
    path: '/registSearchOrg',
    title: '注册',
    meta: { requireAuth: false },
    component: () => import('@/views/login/registSearchOrg.vue')
  },
  {
    path: '/registHasOrgs',
    title: '注册',
    meta: { requireAuth: false },
    component: () => import('@/views/login/registHasOrgs.vue')
  },
  {
    path: '/registSetName',
    title: '注册',
    meta: { requireAuth: false },
    component: () => import('@/views/login/registSetName.vue')
  },
  {
    path: '/forgetPwd',
    title: '忘记密码',
    meta: { requireAuth: false },
    component: () => import('@/views/login/forgetPwd.vue')
  },
  {
    path: '/resetPwd',
    title: '重置密码',
    meta: { requireAuth: false },
    component: () => import('@/views/login/resetPwd.vue')
  },
  {
    path: '/resetDefaultPwd',
    title: '重置默认密码',
    meta: { requireAuth: false },
    component: () => import('@/views/login/resetDefaultPwd.vue')
  },
  {
    path: '/success',
    title: '成功',
    meta: { requireAuth: false },
    component: () => import('@/views/login/success.vue')
  }
]
/* 活动答题 */
const activeQuestion = [
  {
    path: '/activeQueList/:id',
    meta: { requireAuth: true, title: '答题' },
    component: () => import('@/views/activePlay/quickAnswer/list.vue')
  },
  {
    path: '/activeAddQue/:id',
    meta: { requireAuth: true, title: '新建答题卡' },
    component: () => import('@/views/activePlay/quickAnswer/add.vue')
  },
  {
    path: '/activeAddQueSuccess/:id',
    meta: { requireAuth: true, title: '新建答题卡成功' },
    component: () => import('@/views/activePlay/quickAnswer/addSuccess.vue')
  },
  {
    path: '/activeQueDetail/:id',
    meta: { requireAuth: true, title: '答题卡详情' },
    component: () => import('@/views/activePlay/quickAnswer/detail.vue')
  },
  /* 复杂答题-答题详情 */
  {
    path: '/activeAnsDetail/:id',
    meta: { requireAuth: true, title: '答题详情' },
    component: () => import('@/views/activePlay/quickAnswer/answerDetail.vue')
  },
  {
    path: '/activeAnsDetailPerson/:id',
    meta: { requireAuth: true, title: '答题详情' },
    component: () => import('@/views/activePlay/quickAnswer/answerDetailPerson.vue')
  },
  /* 以上都是复杂答题,以下为简单答题 */
  {
    path: '/activeSimpleDetail/:id',
    meta: { requireAuth: true, title: '答题' },
    component: () => import('@/views/activePlay/quickAnswer/simple/simpleDetail.vue')
  },
  {
    path: '/activeSimpleAdd/:id',
    meta: { requireAuth: true, title: '答题' },
    component: () => import('@/views/activePlay/quickAnswer/simple/add.vue')
  },
  {
    path: '/radomPerson/:id',
    meta: { requireAuth: true, title: '随机选人' },
    component: () => import('@/views/activePlay/randomPerson/index.vue')
  }
]

const certificate = [
  {
    path: '/certificate/index',
    name: 'certificate-index',
    component: resolve => {
      require(['../views/certificate/index'], resolve)
    },
    meta: {
      title: '证书申请',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/certificate/applyform/:id',
    name: 'certificate-applyform',
    component: resolve => {
      require(['../views/certificate/applyForm'], resolve)
    },
    meta: {
      title: '证书申请',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/certificate/detail/:id',
    name: 'certificate-detail',
    component: resolve => {
      require(['../views/certificate/detail'], resolve)
    },
    meta: {
      title: '证书申请',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/certificate/look/:id',
    name: 'certificate-look',
    component: resolve => {
      require(['../views/certificate/look'], resolve)
    },
    meta: {
      title: '证书申请',
      bg: '#F4F6F9'
    }
  }
]

const routes = [
  ...login,
  ...tv,
  ...certificate,
  ...customization,
  {
    path: '/',
    redirect: '/home',
    meta: { requireAuth: true },
    component: () => import('../views/layout.vue'),
    children: [
      {
        path: '/home',
        title: '首页',
        meta: { requireAuth: true, title: '首页' },
        component: () => import('@/views/home')
      },
      {
        path: '/pdf',
        title: '附件',
        meta: { title: '附件' },
        component: () => import('@/views/pdf')
      },
      {
        path: '/discover',
        title: '网络教研',
        meta: { requireAuth: true, title: '网络教研' },
        component: () => import('@/views/discover')
      },
      {
        path: '/my',

        meta: { requireAuth: true, title: '我的' },
        component: () => import('@/views/my')
      }
    ]
  },
  // 发现无tab-bar
  {
    path: '/dis',
    meta: { requireAuth: true, title: '发现' },
    component: () => import('@/views/discover')
  },
  {
    path: '/play/:id',
    name: 'play-page',
    meta: { requireAuth: false, title: '活动详情' },
    component: () => import('@/views/activePlay')
  },
  ...activeQuestion,
  {
    path: '/resourcePlay/:id',
    meta: { requireAuth: true, title: '资源详情' },
    component: () => import('@/views/activePlay/resourcePlay.vue')
  },
  {
    path: '/live',
    meta: { requireAuth: true, title: '直播' },
    component: () => import('@/views/live')
  },
  {
    path: '/activeCheck',
    meta: { requireAuth: true, title: '活动签到' },
    component: () => import('@/views/activeCheck')
  },
  {
    path: '/activeView',
    meta: { requireAuth: true, title: '活动详情' },
    component: () => import('@/views/activeCheck/activeview.vue')
  },
  {
    path: '/edCertificate',
    meta: { requireAuth: true, title: '继教证明' },
    component: () => import('@/views/edCertificate')
  },
  {
    path: '/newCertificate',
    meta: { requireAuth: true, title: '继教证明' },
    component: () => import('@/views/edCertificate/newCertificate')
  },
  {
    path: '/oldCertificate',
    meta: { requireAuth: true, title: '旧证书查询' },
    component: () => import('@/views/edCertificate/oldCertificate')
  },
  {
    path: '/labels',
    meta: { requireAuth: true, title: '标签筛选' },
    component: () => import('@/views/discover/labelSelect.vue')
  },
  {
    path: '/subjects',
    meta: { requireAuth: true, title: '学科筛选' },
    component: () => import('@/views/discover/subjectSelect.vue')
  },
  {
    path: '/search',
    meta: { requireAuth: true, title: '搜索' },
    component: () => import('@/views/discover/search.vue')
  },
  {
    path: '/type/:id',
    meta: { requireAuth: true, title: '搜索' },
    component: () => import('@/views/discover/type.vue')
  },
  {
    path: '/new/:id',
    title: '详情',
    meta: { requireAuth: true, title: '详情' },
    component: () => import('@/views/home/newsDetail.vue')
  },
  {
    path: '/noticesMore',
    meta: { requireAuth: true, title: '通知' },
    component: () => import('@/views/home/noticesMore.vue')
  },
  {
    path: '/newsMore',
    meta: { requireAuth: true, title: '新闻' },
    component: () => import('@/views/home/newsMore.vue')
  },
  {
    path: '/active',
    meta: { requireAuth: true, title: '今日活动' },
    component: () => import('@/views/active')
  },
  {
    path: '/alumn',
    meta: { requireAuth: true, title: '专辑' },
    component: () => import('@/views/home/alumn/list.vue')
  },
  {
    path: '/alumn/:id',
    meta: { requireAuth: true, title: '专辑内容' },
    component: () => import('@/views/home/alumn/detail.vue')
  },
  {
    path: '/about',
    meta: { requireAuth: true, title: '关于' },
    component: () => import('@/views/my/about')
  },
  {
    path: '/history',
    meta: { requireAuth: true, title: '观看历史' },
    component: () => import('@/views/my/history')
  },
  {
    path: '/feedback',
    title: '意见反馈',
    meta: { requireAuth: true },
    component: () => import('@/views/my/feedback')
  },
  {
    path: '/project',
    meta: { requireAuth: true, title: '上传作业' },
    component: () => import('@/views/my/project')
  },
  {
    path: '/projectDetail/:code',
    meta: { requireAuth: true, title: '上传作业' },
    component: () => import('@/views/my/projectDetail')
  },
  {
    path: '/projectUpload/:code',

    meta: { requireAuth: true, title: '上传作业' },
    component: () => import('@/views/my/projectUpload')
  },
  {
    /* 评课成功 */
    path: '/courseSuccess',

    meta: { requireAuth: true, title: '提交成功' },
    component: () => import('@/views/activePlay/course/success.vue')
  },
  {
    /* 评课报告 */
    path: '/courseReport',
    meta: { requireAuth: true, title: '评课报告' },
    component: () => import('@/views/activePlay/course/report.vue')
  },
  /* 没有权限 */
  {
    path: '/validPwd/:id',
    meta: { title: '密码验证' },
    component: () => import('@/views/validPwd.vue')
  },
  {
    path: '/401',
    meta: { title: '401' },
    component: () => import('@/views/401.vue')
  },
  {
    /* 租户404 */
    path: '/404',
    meta: { title: '404' },
    component: () => import('@/views/404.vue')
  },
  {
    /* 租户404 */
    path: '/test',
    meta: { title: 'test' },
    component: () => import('@/views/test.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  console.log('beforeEach', to)
  const html = document.getElementsByTagName('html')[0]
  const cssList = html.style.cssText.split(';')
  if (to.path === '/home' && Vue.prototype.filterGray) {
    html.style.filter = 'grayscale(1)'
    html.style.webkitFilter = 'grayscale(1)'
  } else {
    html.style = cssList[0]
  }

  document.title = to.meta.title || '网络教研'
  sessionStorage.setItem('backPath', from.path)
  store.commit('setHasAccess', false)
  next()
  // if (to.meta.requireAuth) {
  //   const {data} = await getUser()
  //   if (data) {
  //     store.commit('setUser', data)
  //     next()
  //   } else {
  //     localStorage.clear()
  //     next('/login')
  //   }
  // } else {
  //   store.commit('setHasAccess', false)
  //   next()
  // }
})

export default router
